import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "420px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

// Hard block while the test's photos are not reaching the server (connection down, a firewall,
// VPN or antivirus blocking the upload, or the photo loop stuck). No dismiss: the candidate
// cannot go on without photos. ImageProctoring keeps retrying and closes it as soon as a photo
// gets through. For a network block the test timer keeps running. When our server is the
// problem (cause "server") the timer is paused while ImageProctoring allows it (serverPauseState
// "paused"); "running" = the pause allowed for this test is used up; "expired" = this block
// lasted too long, so the candidate is asked to resume later from the dashboard.
export default function PhotoNotSentModal({ open, cause, serverPauseState, onGoToDashboard }) {
  const classes = useStyles();

  return (
    <div>
      <Modal
        disableEnforceFocus={true}
        disableEscapeKeyDown
        aria-labelledby="photo-not-sent-modal-title"
        aria-describedby="photo-not-sent-modal-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            {cause !== "server" ? (
              <>
                <h3 id="photo-not-sent-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                  Connection Problem
                </h3>
                <p id="photo-not-sent-modal-description">
                  Your proctoring photos are not reaching us, so you can't continue until this is fixed. Please check your internet connection, and turn off any VPN or firewall that may be blocking this website.
                </p>
                <p style={{ marginTop: "10px" }}>
                  We are trying again automatically. The test will continue as soon as a photo goes through. Your timer is still running.
                </p>
              </>
            ) : serverPauseState === "expired" ? (
              <>
                <h3 id="photo-not-sent-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                  Please Resume Later
                </h3>
                <p id="photo-not-sent-modal-description">
                  We could not fix the problem on our side in time. Your answers and remaining time are saved. Please go to your dashboard and resume the test after some time.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                  <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onGoToDashboard}>
                    <strong>Go to Dashboard</strong>
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 id="photo-not-sent-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                  Problem On Our Side
                </h3>
                <p id="photo-not-sent-modal-description">
                  Your proctoring photos are not being saved because of a problem on our side, not your connection. You can't continue until this is fixed.
                </p>
                <p style={{ marginTop: "10px" }}>
                  {serverPauseState === "paused"
                    ? "Your timer is paused. We are trying again automatically, and the test will continue as soon as a photo goes through."
                    : serverPauseState === "running"
                      ? "We are trying again automatically, and the test will continue as soon as a photo goes through. The paused time allowed for this test is used up, so your timer is running."
                      : "We are trying again automatically, and the test will continue as soon as a photo goes through. Your timer is still running."}
                </p>
              </>
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
